/** @file Spinner: a small busy indicator (loading project, rebuilding preview). */
import type { ReactElement } from 'react';

/** A spinning ring with an accessible `label` (default "Loading"). */
export function Spinner({ label = 'Loading' }: { label?: string }): ReactElement {
  return <span className="p3-spinner" role="status" aria-label={label} />;
}
